module.exports = __webpack_public_path__ + "static/media/mht_790_manitou_001.9cb2d390.png";